/**
 * Centralized query key factories for TanStack React Query.
 * Follows the hierarchy pattern from useReviews.ts:reviewKeys.
 */
export const walletKeys = {
    all: ['playerWallet'],
    summary: (mode = 'full', subjectKey = 'anonymous') => [...walletKeys.all, 'summary', mode, subjectKey],
    transactions: () => [...walletKeys.all, 'transactions'],
};
export const bookingKeys = {
    all: ['bookings'],
    details: () => [...bookingKeys.all, 'detail'],
    detail: (clubCode, teeTimeId) => [...bookingKeys.details(), clubCode, teeTimeId],
};
export const cartIncidentKeys = {
    all: ['cartIncidents'],
    lists: () => [...cartIncidentKeys.all, 'list'],
    list: (status) => [...cartIncidentKeys.lists(), status],
};
export const buddyKeys = {
    all: ['buddyDetails'],
    details: (buddyIdKey) => [...buddyKeys.all, buddyIdKey],
};
//# sourceMappingURL=queryKeys.js.map